import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

import { Box } from '../Box';
import type { PriceSize } from './Price';

export const PriceFreeValue = styled(Box)`
  text-transform: uppercase;

  ${({ theme }) => css`
    p {
      color: ${theme.colors.primaryDark};
      font-family: ${theme.fontFamilies.italianPlate};
    }
  `}
`;

export const getFontSize = (size: PriceSize, isPrice: boolean) => {
  switch (size) {
    case 'xl': {
      return isPrice ? theme.fontSizes.h3 : theme.fontSizes.h5;
    }

    case 'l': {
      return theme.fontSizes.h4Mobile;
    }

    case 'm': {
      return theme.fontSizes.h5Mobile;
    }

    case 's': {
      return theme.fontSizes.p2;
    }

    case 'inherited': {
      return 'inherit';
    }
  }
};

export const Price = styled(Typography)<{ size: PriceSize }>`
  font-size: ${({ size }) => getFontSize(size, true)};

  ${({ size, theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${size === 'inherited' ? 'inherit' : theme.colors.primaryDark};
  `}

  span {
    font-size: ${({ size }) => getFontSize(size, false)};
  }
`;
